import { THAI } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Thai
const THSection: Section[] = [
  {
    name: '1: การอ้างอิงวัตถุอันตราย',
    subSections: [
      {
        name: 'คำนำ',
        page: 3,
      },
      {
        name: 'วัตถุประสงค์และขอบเขตแนะนำการใช้งาน',
        page: 4,
      },
      {
        name: 'คำจำกัดความสำคัญ',
        page: 5,
      },
      {
        name: 'ลำดับขั้นของการควบคุม',
        page: 6,
      },
    ],
  },
  {
    name: '2: โปรแกรม LIFEsaver',
    subSections: [
      {
        name: 'ความปลอดภัยในการใช้ยานพาหนะ ‑ การสัญจร',
        page: 9,
      },
      {
        name: 'การปฏิบัติงานบนที่สูง',
        page: 12,
      },
      {
        name: 'อุปกรณ์ที่ใช้กำลังไฟแบบเคลื่อนที่ ( MPE)',
        page: 18,
      },
      {
        name: 'ล็อคเอาท์-แทกเอาท์ (Lockout- Tagout) / ตัดแยกพลังงาน (Energy Isolation)',
        page: 22,
      },
      {
        name: 'งานไฟฟ้า',
        page: 25,
      },
      {
        name: 'พื้นที่อับอากาศ',
        page: 29,
      },
      {
        name: 'วัสดุปริมาณมากและที่จัดเก็บ',
        page: 32,
      },
      {
        name: 'ความปลอดภัยในการปฏิบัติงานกับรถเดินราง',
        page: 37,
      },
      {
        name: 'งานขุดเจาะและขุด',
        page: 41,
      },
      {
        name: 'การยกและแขวนโยง',
        page: 45,
      },
      {
        name: 'วัสดุอันตราย',
        page: 49,
      },
      {
        name: 'งานทีก่อให้เกิดความร้อนประกายไฟ',
        page: 52,
      },
    ],
  },
  {
    name: '3: เครื่องมือและแหล่งข้อมูลเพิ่มเติม',
    subSections: [
      {
        name: 'การทำงานเหนือน้ำและรอบๆ บริเวณที่มีน้ำ',
        page: 56,
      },
      {
        name: 'การตกของวัตถุ - การคำนวนการตก',
        page: 59,
      },
      {
        name: 'การทดสอบบรรยากาศ/ก๊าซ',
        page: 61,
      },
      {
        name: 'การสื่อสารสื่ออันตรายของสารเคมี',
        page: 65,
      },
    ],
  },
  {
    name: '4: แนวทางในการจัดการด้าน ความปลอดภัยของคาร์กิลล์',
    subSections: [
      {
        name: 'คำศัพท์สำคัญ',
        page: 70,
      },
      {
        name: 'การวิเคราะห์การบาดเจ็บสาหัสและ การเสียชีวิต (SIF)',
        page: 72,
      },
      {
        name: 'การจำแนกประเภทแนวโน้ม ของการบาดเจ็บสาหัสและการเสียชีวิต (SIFp)',
        page: 73,
      },
      {
        name: 'ตารางเกณฑ์ การวิเคราะห์ SIF อัตโนมัติ',
        page: 74,
      },
      {
        name: 'ประสิทธิภาพของพนักงานและ องค์กร (HOP)',
        page: 76,
      },
    ],
  },
];
const THTableofContent: TableOfContent = {
  language: 'th',
  sections: THSection,
  label: 'สารบัญ',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (th_TH)_DIGITAL_CROPPED.pdf',
  hopPocket: 'คู่มือ HOP ฉบับพกพา',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Thai.pdf',
  source: THAI,
};

export default THTableofContent;
